// @ts-nocheck

export const isMultiviewRoute = (pathname: string): boolean => {
  return !!pathname.match('/multiplex$');
};
